import React, {useEffect, useState} from "react";
import {Button, Card, Grid, Typography} from '@mui/material/';
import SearchBar from "../components/SearchBar";
import mentor_pic from './../mentor_pic.jpeg';
import axios from "axios";
import dummyMentors from "./../json/top3mentors.json";
import {Link, useNavigate} from 'react-router-dom';
import * as constants from './../constants'
import {List, ListItem} from "@mui/material";
import MenuAppBar from "../components/MenuAppBar";

/**
 * Displays a list of all mentors
 * @returns {Element}
 * @constructor
 */
export default function AllMentors() {
    const [error, setError] = useState('')
    const [mentors, setMentors] = useState(dummyMentors)

    //Run when first loading
    useEffect(() => {
        //get list of all mentors from the server
        axios.get(constants.serverURL + "allMentors",      {
            withCredentials: true,
        }).then(response => {
            setMentors(response.data)
        }).catch((error) => {
            if (error.request.responseText === 'expired token') {
                window.location.href = constants.websiteURL + '#/refreshToken?redirect=topMentors'
            } else {
                setError(error.request.responseText)
            }
        })
    }, [])


    /**
     * filterData()
     * Search funciton
     * @param query
     * @param data
     * @returns {*}
     */
    const filterData = (query, data) => {
        if (!query) {
          return data;
        } else {
          return data.filter(d => d.name.toLowerCase().includes(query.toLowerCase()));
        }
    };
    
    const [query, setQuery] = useState("");
    const filteredMentors = filterData(query, mentors);
    const navigate = useNavigate();

    /**
     * bookSession()
     * Takes the user to BookSession.js
     * @param mentor
     */
    const bookSession = (mentor) => {
        navigate('/booksession?mentorId=' + mentor.id, {state:{mentor:mentor}});
    };

    //Render page
    return (
        <div>
            <MenuAppBar title="Mentee Survey" signedIn={true}></MenuAppBar>
            <div className="screen">
                <List>
                {
                    error &&
                    <ListItem sx={{ p:2, my:1.5}} className='question-block'>
                        <Typography className="font-16 error-message">{error}</Typography>
                    </ListItem>
                }
                </List>
                <p className="center-align font-20">Meet our mentors!</p>
                <SearchBar name="search" placeholder="Search for a mentor" query={query} setQuery={setQuery}/>
                <Grid container spacing={3} className="mentor-container">
                {
                    filteredMentors.map(mentor => (
                        <Grid item xs={12} sm={6} md={4} lg={3} className="center-align" key={mentor.id}>
                            <Card id={mentor.id} className="mentor-card">
                                <p className="center-align font-18">{mentor.name}</p>
                                <img
                                src={constants.mentorImageBucketURL + mentor.id + '.png'}
                                alt="Not Found"
                                className="circle"
                                />
                                <p className="center-align font-14">{mentor.description}</p>
                                <div className="button-group center-align">
                                    <Button className="m-form-button" variant="outlined" onClick={() => bookSession(mentor)}>Book a session</Button>
                                    {/* <Button className="m-form-button" variant="outlined">Get to know them more</Button> */}
                                </div>
                            </Card>
                        </Grid>
                    ))
                }
                </Grid>
                <Link className="font-16 primary-color" to="/topMentors">Go back to top 3 &gt;&gt;</Link>
                <Link className="font-16 primary-color" to="/menteeform">Take the survey again &gt;&gt;</Link>
            </div>
        </div>
    )
}
